import React, { Component } from "react";
import UserAPIGateway from "accounts/gateways/user";
import queryString from "query-string";
import PropTypes from "prop-types";

class JobTrackIframeEmbed extends Component {
  state = {
    src: null,
    loading: true,
  };

  goTo(pathname, params) {
    const {
      router: { history },
    } = this.context;
    history.push({ pathname, search: queryString.stringify(params) });
  }

  handleIframeMessage = (event) => {
    const allowedOrigin = process.env.REACT_APP_JOBTRAKS_BASE_URL;

    if (!allowedOrigin.startsWith(event.origin)) {
      console.warn(`Blocked message from unauthorized origin: ${event.origin}`);
      return;
    }

    const { type, data } = event.data;
    if (typeof type !== "string") return;

    if (type.startsWith("COLUMN_CLICK_EVENT_")) {
      const match = type.match(/^COLUMN_CLICK_EVENT_(\d+)_(.+)$/);
      if (!match || !data) return;
      const { employee: employeeId, job_id: jobId } = data;
      const columnKey = match[2];
      if (columnKey === "route_name" && data?.route_id) {
        this.goTo(`/jobTrack/routes/view`, { route_id: data.route_id });
        return;
      }
      if (columnKey === "employee_name" && data?.employee_id) {
        this.goTo(`/employee/${data.employee_id}/edit/detail`);
        return;
      }
      if (employeeId) {
        if (employeeId) {
          this.goTo(`/employee/${employeeId}/edit/employeeWagesAndCost`, {
            empName: data.name,
            empWage: data.wage,
            empId: employeeId,
          });
        }
      } else if (jobId) {
        this.goTo(`/job/list/${jobId}/edit`);
      }
      return;
    }
    if (type.startsWith("EMITTER_PANEL_PERMISSION_")) {
      const match = type.match(/^EMITTER_PANEL_PERMISSION_(\d+)_(.+)$/);
      if (!match || !data) return;

      const buttonType = data?.name;

      const routes = {
        Employees: "/employee/add",
        Jobs: "/job/list/add",
      };

      if (buttonType && routes[buttonType]) {
        this.goTo(routes[buttonType]);
        return;
      }
      if (data?.id) {
        this.goTo("/employee/add");
      }
    }
  };

  async componentDidMount() {
    await this.ensureValidTokenAndSetSrc();
    window.addEventListener("message", this.handleIframeMessage);
  }

  componentDidUpdate(prevProps) {
    // Re-check if src changes (e.g., key or type changes)
    if (
      prevProps.key !== this.props.key ||
      prevProps.type !== this.props.type
    ) {
      this.ensureValidTokenAndSetSrc();
    }
  }

  // Use predefined API function instead of hardcoding fetch
  fetchNewToken = async () => {
    try {
      const apiGateway = new UserAPIGateway();
      const tokenResponse = await apiGateway.getJobTrackToken();
      return tokenResponse;
    } catch (error) {
      return null;
    }
  };

  componentWillUnmount() {
    window.removeEventListener("message", this.handleIframeMessage);
  }

  // Ensure token is valid, refresh if expired
  ensureValidTokenAndSetSrc = async () => {
    const loginTimestamp = localStorage.getItem("loginTimestamp");
    const now = Date.now();
    const expiryTime = localStorage.getItem("iframe_jwt_token_expiry") * 1000; // convert seconds to ms

    let JobTrackAuthToken = localStorage.getItem("JobTrackBearerToken");
    let jwtToken = localStorage.getItem("iframe_jwt_token");
    let orgId = localStorage.getItem("jobTrackOrgId");

    if (!loginTimestamp || now - loginTimestamp > expiryTime) {
      const tokenResponse = await this.fetchNewToken();
      if (tokenResponse) {
        JobTrackAuthToken = tokenResponse.access_token;
        jwtToken = tokenResponse.jwt_token;

        // Keep old orgId, do not overwrite
        const oldOrgId = localStorage.getItem("jobTrackOrgId");
        orgId = oldOrgId;
        if (!orgId) {
          return;
        }

        // Update tokens in localStorage
        localStorage.setItem("JobTrackBearerToken", JobTrackAuthToken);
        localStorage.setItem("iframe_jwt_token", jwtToken);
        localStorage.setItem("loginTimestamp", now);
      }
    }

    if (JobTrackAuthToken && jwtToken && orgId) {
      // Build iframe URL dynamically
      const { src: originalSrc } = this.props;
      const url = new URL(originalSrc);

      url.searchParams.set("access_token", JobTrackAuthToken);
      url.searchParams.set("jwt_token", jwtToken);
      url.searchParams.set("orgId", orgId);
      url.searchParams.set("jwt_expiry", "3600");
      url.searchParams.set("embed", "true");

      this.setState({ src: url.toString(), loading: false });
    } else {
      this.setState({ loading: true });
    }
  };

  render() {
    const { type } = this.props;
    const { src, loading } = this.state;

    if (loading) return <div>Loading...</div>;

    return (
      <iframe
        title="component-preview"
        width="100%"
        src={src}
        style={{
          border: "none",
          position: "absolute",
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          width: "100%",
          height: type ? "67%" : "100%",
          marginTop: type && "14rem",
        }}
        allowFullScreen
      />
    );
  }
}

JobTrackIframeEmbed.propTypes = {
  history: PropTypes.object.isRequired,
};

JobTrackIframeEmbed.contextTypes = {
  router: PropTypes.object.isRequired,
};

export default JobTrackIframeEmbed;
